import {
  InstructionComponentType,
  AttachmentInstructionType,
  InstructionDiffStatus,
} from '@scale/shared/defaults';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  IInstructionExampleSampleJson,
  IInstructionExampleJson,
} from '@scale/shared/projectInstruction/types';
import { IndividualSpecialization } from '@scale/shared/task_lint/linters/categorization';

export interface NormalizedComponentProps {
  nodeName: string;
  nodeType: InstructionComponentType | 'ToolTutorials';
  nodeId: string;
  iconName: IconProp;
  iconColor: string;
  content?: ContentType;
  waitSeconds?: number | null;
  components?: NormalizedComponentProps[];
  nestedAttributeIds?: string[];
  nestedLabelIds?: string[];
}
export interface SearchResultItemProps {
  type?: string;
  description: string;
  title: string;
  nodeId: string;
  path: any[];
  linkedTask: string;
  staticAsset: any;
  isNew?: boolean;
  didChange?: boolean;
  screenshotUrl: string;
  videoUrl?: string;
}
type ContentType = ComponentJson;

export const DIFF_STATUS_LABEL: Record<InstructionDiffStatus, string> = {
  [InstructionDiffStatus.Addition]: 'New',
  [InstructionDiffStatus.Update]: 'Changed',
  [InstructionDiffStatus.Deletion]: 'Removed',
};

export interface ComponentJson {
  _id: string;
  type: InstructionComponentType;
  title: string;
  description: string;
  examples?: IInstructionExampleJson[];
  samples?: IInstructionExampleSampleJson[];
  components?: ComponentJson;
  isNew?: boolean;
  diffStatus?: InstructionDiffStatus;
  labels?: string[];
  attributes?: string[];
  label?: string;
  attribute?: string;
  waitSeconds?: number | null;
  attachmentType?: AttachmentInstructionType;
  ontologyProjectId?: string;
  specializations?: IndividualSpecialization[][];
  nestedAttributeIds?: string[];
  nestedLabelIds?: string[];
  hiddenFromCustomer?: boolean;
}

export interface ExtraAlertsProps {
  isEdgeCase?: boolean;
  hasSensitiveContent?: boolean;
  param_chunks?: boolean;
}

export type SelectedPathType = [InstructionComponentType | 'ToolTutorials', string | null] | [];
